import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbsolutePipe } from './pipes/absolute.pipe';
import { Base64DecodePipe } from './pipes/base64decode.pipe';
import { DashIfEmptyPipe } from './pipes/dash-if-empty.pipe';
import { FilterEmptyEntriesPipe } from './pipes/filter-empty-entries.pipe';
import { HumanReadableSecondsPipe } from './pipes/human-readable-seconds.pipe';
import { MaintainOrderKeyValuePipe } from './pipes/maintain-order-key-value.pipe';
import { RcpFormattedDatePipe } from './pipes/rcp-formatted-date.pipe';
import { RcpWordedDatePipe } from './pipes/rcp-worded-date.pipe';
import { RouteRelativeToAnchorPipe } from './pipes/route-relative-to-anchor.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeSrcPipe } from './pipes/safe-src.pipe';

const pipes = [
  AbsolutePipe,
  RcpFormattedDatePipe,
  RcpWordedDatePipe,
  MaintainOrderKeyValuePipe,
  SafeHtmlPipe,
  SafeSrcPipe,
  Base64DecodePipe,
  HumanReadableSecondsPipe,
  DashIfEmptyPipe,
  FilterEmptyEntriesPipe,
  RouteRelativeToAnchorPipe,
];

@NgModule({
  imports: [CommonModule, ...pipes],
  exports: [...pipes],
})
export class SharedPipesModule {}
